import styles from "./app-menu.style.module.scss";
let-local-storage/conciseMode=false key="concise-mode"
script --
  document.documentElement.classList.toggle("concise-mode", conciseMode);
html-script --
  ${
    `document.documentElement.classList.toggle("concise-mode",localStorage.getItem("concise-mode")==='true');`
  };

let-local-storage/tsMode=true key="ts-mode"
script -- document.documentElement.classList.toggle("ts-mode", tsMode);
html-script --
  ${
    `document.documentElement.classList.toggle("ts-mode",localStorage.getItem("ts-mode")==='true');`
  };

div#site-menu class=styles.menu
  define/Page|{ value, content }: { value: string; content: Marko.Body }|
    li
      a href=value aria-current=($global.url.pathname === value && "true")
        ${content}

  nav/$nav class=styles.nav id=styles.siteNav
    ul
      li
        strong -- Newsletter
        ul
          Page="/docs/newsletter/june-2026" -- June
          Page="/docs/newsletter/may-2026" -- May
          Page="/docs/newsletter/april-2026" -- April
          Page="/docs/newsletter" -- ...more
      li
        strong -- Introduction
        ul
          Page="/docs/introduction/getting-started" -- Getting Started
          Page="/docs/introduction/welcome-to-marko" -- Welcome to Marko!
          Page="/docs/introduction/installation" -- Installation
          Page="/docs/introduction/why-marko" -- Why Marko?
          Page="/docs/introduction/integrations" -- Integrations
      li
        strong -- Tutorials
        ul
          Page="/docs/tutorial/fundamentals" -- Fundamentals
          Page="/docs/tutorial/components-and-reactivity" --
            Components and Reactivity
      li
        strong -- Guides
        ul
          Page="/docs/guide/styling" -- Styling
          Page="/docs/guide/forms" -- Forms
          Page="/docs/guide/duplicate-form-submissions" --
            Duplicate Form Submissions
          Page="/docs/guide/marko-5-interop" -- Marko 5 Interop
      li
        strong -- Explanation
        ul
          Page="/docs/explanation/why-is-marko-fast" -- Why is Marko Fast?
          Page="/docs/explanation/streaming" -- Streaming
          Page="/docs/explanation/targeted-compilation" -- Targeted Compilation
          Page="/docs/explanation/fine-grained-bundling" --
            Fine-Grained Bundling
          Page="/docs/explanation/separation-of-concerns" --
            Separation of Concerns
          Page="/docs/explanation/controllable-components" --
            Controllable Components
          Page="/docs/explanation/nested-reactivity" -- Nested Reactivity
          Page="/docs/explanation/immutable-state" -- Immutable State
          Page="/docs/explanation/serializable-state" -- Serializable State
          Page="/docs/explanation/class-vs-tags-api" -- Class to Tags API
      li
        strong -- Reference
        ul
          Page="/docs/reference/language" -- Language
          Page="/docs/reference/custom-tag" -- Custom Tags
          Page="/docs/reference/reactivity" -- Reactivity
          Page="/docs/reference/core-tag" -- Core Tags
          Page="/docs/reference/native-tag" -- Native Tags
          Page="/docs/reference/lazy-loading" -- Lazy Loading
          Page="/docs/reference/typescript" -- TypeScript
          Page="/docs/reference/template" -- Template API
          Page="/docs/reference/concise-syntax" -- Concise Syntax
          Page="/docs/reference/supported-environments" -- Runtime Support
      li
        strong -- Marko Run
        ul
          Page="/docs/marko-run/getting-started" -- Getting Started
          Page="/docs/marko-run/file-based-routing" -- File-based Routing
          Page="/docs/marko-run/typescript" -- TypeScript
  div id=styles.controls
    label class=styles.versionControl
      -- Version&nbsp;
      select onChange(_, el) {
        const { value } = el;
        if (value) {
          el.selectedIndex = 0;
          location.href = value;
        }
      }
        option value="" selected -- 6.x
        option value="https://v5.markojs.com/docs/getting-started" -- 5.x
        option value="http://marko-v4.github.io/docs/" -- 4.x
        option value="http://v3.markojs.com/docs/" -- 3.x
        option value="http://marko-v2.github.io/docs/" -- 2.x
    app-switch
      ,aria-label="Toggle Concise mode"
      ,checked:=conciseMode
      ,off="HTML"
      ,on="Concise"
    app-switch aria-label="Toggle TS mode" checked:=tsMode off="JS" on="TS"

html-script --
  ${
    `document.getElementById("${styles.siteNav}").scrollTop = +(sessionStorage.getItem("menu-scroll-position") || 0)`
  };
script --
  addEventListener(
    "beforeunload",
    () => {
      sessionStorage.setItem("menu-scroll-position", $nav().scrollTop + "");
    },
    {
      signal: $signal,
    },
  );
